import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';

@Pipe({
  name: 'categoryCost'
})
export class CategoryCostPipe implements PipeTransform {
  public transform(category: Category): number {
    let total = 0;
    const classificationTotals = {};

    for (const estimateLine of category.estimateLines) {
      for (const classificationLine of estimateLine.classificationLines) {
        classificationTotals[classificationLine.classificationEstimateId] = classificationLine.hours;
        total += classificationLine.hours * classificationLine.rateCost;
      }
    }

    return total;
  }
}
